import React from "react";
import { logError } from "trackers";

function DefaultErrorComponent() {
  return <div>Something went wrong.</div>;
}

class ErrorBoundary extends React.Component {
  static defaultProps = {
    errorComponent: DefaultErrorComponent,
  };

  constructor(props) {
    super(props);
    this.state = { catchedError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { catchedError: true, error };
  }

  clearError = () => {
    this.setState({ catchedError: false, error: null });
  };

  componentDidCatch(error, info) {
    this.setState({ catchedError: true, error });
    logError(error, info);
  }

  render() {
    if (this.state.catchedError) {
      return (
        <this.props.errorComponent
          error={this.state.error}
          clearError={this.clearError}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
